export interface CalendarIntegrationDTO {
    id: number;
    userId: number;
    accountTypeId: number;
    accountTypeName: string;
    appRegistrationId: number;
    appRegistrationName: string;
    calDavId: number;
    caldavName: string;
    iCalId: number;
    iCalName: string;
    authorizationCode: string;
    accessToken: string;
    refreshToken: string;
    description: string;
    provider: string;
    email: string;
}

export interface CalendarIntegrationWriteDTO {
    userId: number;
    accountTypeId: number;
    appRegistrationId: number;
    calDavId: number;
    iCalId: number;
    authorizationCode: string;
    accessToken: string;
    refreshToken: string;
    description: string;
    email: string;
}

export function createCalendarIntegrationDTO(id: number, userId: number,
    accountTypeId: number,
    accountTypeName: string,
    appRegistrationId: number,
    appRegistrationName: string,
    calDavId: number,
    caldavName: string,
    iCalId: number,
    iCalName: string,
    authorizationCode: string,
    accessToken: string,
    refreshToken: string,
    description: string,
    provider: string,
    email: string
) {
    return {
        id: id, userId: userId, accountTypeId: accountTypeId, accountTypeName: accountTypeName, appRegistrationId: appRegistrationId, appRegistrationName: appRegistrationName,
        calDavId: calDavId, caldavName: caldavName, iCalId: iCalId, iCalName: iCalName,
        authorizationCode: authorizationCode, accessToken: accessToken, refreshToken: refreshToken, description: description, provider: provider, email: email
    }
}

export function createCalendarIntegration(userId: number,
    accountTypeId: number,
    appRegistrationId: number,
    calDavId: number,
    iCalId: number,
    authorizationCode: string,
    accessToken: string,
    refreshToken: string,
    description: string,
    email: string
) {
    return {
        userId: userId, accountTypeId: accountTypeId, appRegistrationId: appRegistrationId, calDavId: calDavId, iCalId: iCalId,
        authorizationCode: authorizationCode, accessToken: accessToken, refreshToken: refreshToken, description: description, email: email
    }
}